import SignaturePanel from './SignaturePanel';
import { renderPermissionStatus } from './WidgetInfo';

export default SignaturePanel;

export {
  renderPermissionStatus,
  SignaturePanel,
};
